import { z } from "zod";

export const patientPaymentsPageSearchSchema = z.object({
  back: z.number().optional(),
  filter: z.boolean().optional(),
  about: z.boolean().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  action: z.string().optional(),
  status: z.array(z.string()).optional(),
  origins: z.array(z.string()).optional(),
  paymentMethods: z.array(z.string()).optional(),
});

export type PatientPaymentsPageSearchSchema = z.infer<
  typeof patientPaymentsPageSearchSchema
>;
